import React from 'react';
import { useNavigate } from 'react-router-dom';
import Categories from './Categories';
import Header from './Header';
import Footer from './Footer';
import { useAuth } from '../contexts/AuthContext';

const CategoriesPage = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleSignupClick = () => {
    navigate('/signup');
  };


  const handleProfileClick = () => {
    navigate('/profile');
  };

  const handleAccountSettingsClick = () => {
    navigate('/settings');
  };

  const handleCategoriesClick = () => {
    // Already on categories page
  };

  const handleHowItWorksClick = () => {
    navigate('/#how-it-works');
  };

  return (
    <div className="App">
      <Header 
        onLoginClick={handleLoginClick}
        onSignupClick={handleSignupClick}
        isLoggedIn={isAuthenticated}
        user={user}
        onHomeClick={() => navigate('/')}
        onCategoriesClick={handleCategoriesClick}
        onHowItWorksClick={handleHowItWorksClick}
        onProfileClick={handleProfileClick}
        onAccountSettingsClick={handleAccountSettingsClick}
        currentPage="categories"
      />
      <Categories />
      <Footer />
    </div>
  );
};

export default CategoriesPage;
